"use client";

import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

// Card Component
function MoreNews({ image, title, permalink }) {
  return (
    <Link href={permalink}>
      <div className="w-full  mb-2">
        <div className="overflow-hidden rounded-sm">
          <Image
            src={image}
            alt={title}
            width={326}
            height={217}
            className="object-cover w-full"
          />
        </div>

        <h3 className="mt-2 pb-1 text-[18px] font-[800] leading-[20px] text-black line-clamp-3">
          {title}
        </h3>
      </div>
    </Link>
  );
}

export default function MoreNewsSection() {
  const pathname = usePathname();
  const [moreNewsItems, setMoreNewsItems] = useState([]);

  const pathArray = pathname.split("/").filter(Boolean);
  const blacklistedRoutes = ["author", "tag"];
  const isBlacklisted = blacklistedRoutes.includes(pathArray[0]);

  useEffect(() => {
    if (isBlacklisted) return;

    const fetchMoreNews = async () => {
      try {
        const lastSegment = pathArray[pathArray.length - 2];

        if (!lastSegment) return;

        const res = await fetch(
          `${process.env.NEXT_PUBLIC_BASE_URL}/news/v1/posts?category=${lastSegment}&page=1&limit=12`,
          {
            headers: {
              Authorization: `Bearer news_api_9f8sdf98sdf89sdf89sd89f`,
            },
          },
        );

        const data = await res.json();
        setMoreNewsItems(data.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchMoreNews();
  }, [pathname, isBlacklisted]);

  if (isBlacklisted) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {moreNewsItems?.map((item, index) => (
        <MoreNews
          key={index}
          image={item?.thumbnail}
          title={item?.title}
          permalink={item?.permalink}
        />
      ))}
    </div>
  );
}
